import { useCallback, useMemo } from 'react';
import { getDeedIndexForDate, getLocalDateString } from '@/utils/dateUtils';
import { getDeedCategoryByIndex, getDeedCategoryById } from '@/constants/categories';

/**
 * Hook für Streak-Berechnung und Kategorie-Statistiken
 * @param {string[]} completedDates - Array von Datum-Strings (YYYY-MM-DD)
 * @param {Object} completedDeedIds - Object { "YYYY-MM-DD": [deedId1, deedId2] }
 */
export const useStreak = (completedDates, completedDeedIds = {}) => {
  // Streak berechnen
  const calculateStreak = useCallback(() => {
    let streak = 0;
    const now = new Date();
    
    for (let i = 0; i < 365; i++) {
      const date = new Date(now);
      date.setDate(date.getDate() - i);
      const dateString = getLocalDateString(date);
      
      if (completedDates.includes(dateString)) {
        streak++;
      } else if (i > 0) {
        break;
      }
    }
    
    return streak;
  }, [completedDates]);

  const currentStreak = calculateStreak();

  // Kategorie-Statistiken berechnen
  const categoryStats = useMemo(() => {
    const stats = {
      ibadah: 0,
      herz: 0,
      zunge: 0,
      handlung: 0
    };
    
    completedDates.forEach(dateString => {
      const date = new Date(dateString);
      
      // Prüfe, ob wir die tatsächlich gewählte Tat-ID haben
      const deedIdsForDay = completedDeedIds[dateString];
      let category = 'herz'; // Default
      
      if (deedIdsForDay && deedIdsForDay.length > 0) {
        // Verwende die letzte gewählte Tat für diesen Tag
        const deedIdOrIndex = deedIdsForDay[deedIdsForDay.length - 1];
        
        // Die deed.id kann ein Number (z.B. 253) oder ein String sein
        // In beiden Fällen nutzen wir getDeedCategoryById
        category = getDeedCategoryById(deedIdOrIndex);
      } else {
        // Fallback: Berechne Index aus Datum (für alte Daten ohne gespeicherte IDs)
        const deedIndex = getDeedIndexForDate(date, 100);
        category = getDeedCategoryByIndex(deedIndex);
      }
      
      if (stats[category] !== undefined) {
        stats[category]++;
      }
    });
    
    return stats;
  }, [completedDates, completedDeedIds]);

  return {
    currentStreak,
    categoryStats,
    totalCompleted: completedDates.length
  };
};

export default useStreak;
